/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="10.87"
        height="18.99"
        viewBox="0 0 10.87 18.99"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M1.03 2.11a5.43 5.43 0 0 0-.81 4.73 9.28 9.28 0 0 0 1.13 2.53 6.48 6.48 0 0 1 1.13 3.51h-1l.85 4.58h1.15a2 2 0 0 0 3.94 0h1.19l.82-4.58h-1a6.56 6.56 0 0 1 1.13-3.51 9.62 9.62 0 0 0 1.14-2.53 5.47 5.47 0 0 0-9.62-4.73Zm4.4 15.88a1 1 0 0 1-.88-.53h1.77a1 1 0 0 1-.89.53Zm2.32-1.53H3.19l-.49-2.58h5.49ZM9.02 2.69a4.54 4.54 0 0 1 .66 3.9 8.83 8.83 0 0 1-1 2.28 7.44 7.44 0 0 0-1.27 4H5.9V6.98h-1v5.89H3.51a7.51 7.51 0 0 0-1.26-4 8.5 8.5 0 0 1-1-2.28 4.47 4.47 0 0 1 7.83-3.9Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'LightbulbIcon';

export default Icon;
